import { BLOCK_TYPES } from "@shared/blocks";

export const TYPES = {
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  STRING: "string",
  RICH_TEXT: "rich_text",
  COLLECTION: "collection",
};

export const BLOCK_PAGE_ATTRIBUTES = {
  IMAGE_PAGE_ATTRIBUTE: "image_page_attribute",
  VIDEO_PAGE_ATTRIBUTE: "video_page_attribute",
  AUDIO_PAGE_ATTRIBUTE: "audio_page_attribute",
  PAGE_ATTRIBUTE: "page_attribute",
};

export const getTextContent = (textBlock, pageAttributeValues = {}) => {
  const { content, page_attribute } = textBlock.data;

  if (page_attribute && page_attribute.slug) {
    const value = pageAttributeValues[page_attribute.slug];

    if (!value) return content;

    if (page_attribute.type === TYPES.STRING) {
      const body = new DOMParser()
        .parseFromString(content, "text/html")
        .documentElement.querySelector("body");
      const node = body.childNodes[0];

      const nodeHasContent = !!node.textContent;
      const replaceWithHtml = nodeHasContent
        ? node.outerHTML.replace(node.textContent, value)
        : node.outerHTML.replace("></", `>${value}</`);

      return node
        ? body.innerHTML.replace(node.outerHTML, replaceWithHtml)
        : "";
    } else if (page_attribute.type === TYPES.RICH_TEXT) {
      return value.startsWith("<") ? value : `<p>${value}</p>`;
    }
  } else {
    return content;
  }
};

export const parseToAttributeValue = (text, pageAttribute) => {
  if (!text) return "";

  if (pageAttribute.type === TYPES.STRING) {
    return new DOMParser()
      .parseFromString(text, "text/html")
      .documentElement.querySelector("body").childNodes[0].textContent;
  } else if (pageAttribute.type === TYPES.RICH_TEXT) {
    return text.startsWith("<") ? text : `<p>${text}</p>`;
  }
};

export const getDefaultAttributeType = (block) => {
  switch (block.type) {
    case BLOCK_TYPES.TEXT_BLOCK:
      return new DOMParser()
        .parseFromString(block.data.content, "text/html")
        .documentElement.querySelector("body").childNodes.length > 1
        ? TYPES.RICH_TEXT
        : TYPES.STRING;

    case BLOCK_TYPES.HERO_BLOCK:
      return TYPES.IMAGE;
    default:
      return TYPES.STRING;
  }
};
